import { COMPLETE, SELF_CERTIFIED, PENDING } from "../../safety.constants";
import { VIDEO, IN_PERSON, REMOTE, TEXT, SLIDES } from "../../constants";
import mixpanel from "mixpanel-browser";
import safetyMeetingTemplate from "./view_safety_meeting.html";
import _ from "lodash";
import en from "./en.translation.json";
import es from "./es.translation.json";
import { safetyMeetingBaseState } from "../../../../app.routes";
import {
    createCloudinaryPollUrl,
    getCloudinaryUrl,
} from "../../../../common/common/common.utils";

class ViewSafetyMeetingController {
    /* @ngInject */
    constructor(
        moment,
        $state,
        $q,
        $http,
        $interval,
        SafetyMeetingRequestService,
        ToastService,
        $timeout,
        $document,
    ) {
        this.moment = moment;
        this.$state = $state;
        this.COMPLETE = COMPLETE;
        this.$q = $q;
        this.IN_PERSON = IN_PERSON;
        this.REMOTE = REMOTE;
        this.$interval = $interval;
        this.SafetyMeetingRequestService = SafetyMeetingRequestService;
        this.ToastService = ToastService;
        this.$timeout = $timeout;
        this.$document = $document;
        this.$http = $http;
        this.SLIDES = SLIDES;

        this.showCompletion = false;
    }

    $onInit() {
        let ctrl = this;
        ctrl.latestUpdateResponse = ctrl.request
            .starting()
            .catch(function (reason) {
                ctrl.ToastService.create(
                    ctrl.SafetyMeetingRequestService.handleRejection(reason),
                );
            });
        if (ctrl.topic.category === SLIDES) {
            ctrl.$http
                .head(createCloudinaryPollUrl(ctrl.content.pdf_public_id))
                .then(
                    function (response) {},
                    function (response) {
                        if (response.status !== 400) {
                            ctrl.ToastService.create(
                                "viewSafetyMeeting.SLIDES_UNAVAILABLE",
                            );
                            return;
                        }
                        let headers = response.headers();
                        let str = headers["x-cld-error"];
                        let max_page_number = str.match(/[0-9]+/);
                        let slides = [];
                        for (let page = 1; page <= max_page_number; page++) {
                            let url = getCloudinaryUrl(
                                "f_auto,pg_" +
                                    page +
                                    ",q_auto:eco/" +
                                    ctrl.content.pdf_public_id,
                            );
                            slides.push(url);
                        }
                        ctrl.content.slideUrls = slides;
                    },
                );
        }
        ctrl.$timeout(
            function () {
                ctrl.showCompletion = true;
            },
            (ctrl.topic.runtime * 1000) / 3,
        ); // Have the warning show for one third of the expected runtime
    }

    handleSignatureChange(value) {
        let ctrl = this;
        if (ctrl.signatureTimeout) {
            ctrl.$timeout.cancel(ctrl.signatureTimeout);
        }
    }

    handleSignatureUpdate(value, request, account) {
        let ctrl = this;
        ctrl.handleSignatureChange(value);
        ctrl.signatureTimeout = ctrl.$timeout(function () {
            ctrl.$timeout.cancel(ctrl.signatureTimeout);
            ctrl.certifyCompletion(request, account, value);
        }, 4000);
    }

    certifyCompletion(request, account, signatureImageData) {
        let ctrl = this;
        ctrl.showSpinner = true;
        ctrl.latestUpdateResponse.then(function () {
            request.complete(account, SELF_CERTIFIED, signatureImageData).then(
                function () {
                    let mixpanelProperties = {
                        topic__sid: ctrl.topic.sid,
                        topic__runtime: ctrl.topic.runtime,
                        topic__category: ctrl.topic.category,
                        topic__requires_signature:
                            ctrl.topic.requires_signature,
                        company_sid: ctrl.meeting.organizer,
                        mp_trace_id: ctrl.meeting.sid,
                    };
                    if (ctrl.topic.category === TEXT) {
                        mixpanelProperties.topic__number_of_images =
                            ctrl.$document[0]
                                .querySelector("render-markdown")
                                .querySelectorAll("img").length;
                    }
                    mixpanel.track(
                        "Subject certified safety meeting complete",
                        mixpanelProperties,
                    );
                    ctrl.$state.go(
                        safetyMeetingBaseState,
                        {
                            meeting_sid: ctrl.meeting.sid,
                        },
                        {
                            reload: safetyMeetingBaseState,
                        },
                    );
                },
                function (reason) {
                    ctrl.ToastService.create(
                        ctrl.SafetyMeetingRequestService.handleRejection(
                            reason,
                        ),
                    );
                    ctrl.request.status = ctrl.PENDING;
                    ctrl.showSpinner = false;
                },
            );
        });
    }

    trackPlaying() {
        let ctrl = this;
        mixpanel.track("Played topic audio");
    }
}

export default {
    bindings: {
        meeting: "<",
        topic: "<",
        content: "<",
        request: "<",
        account: "<",
        farm: "<",
        wpsTrainer: "<",
    },
    controller: ViewSafetyMeetingController,
    template: safetyMeetingTemplate,
    name: "viewSafetyMeeting",
    translations: { en, es },
};
